import { render, staticRenderFns } from "./r-sky-sprint-config-page.vue?vue&type=template&id=11ecbd72"
import script from "./r-sky-sprint-config-page.vue?vue&type=script&lang=js"
export * from "./r-sky-sprint-config-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ecbd72')) {
      api.createRecord('11ecbd72', component.options)
    } else {
      api.reload('11ecbd72', component.options)
    }
    module.hot.accept("./r-sky-sprint-config-page.vue?vue&type=template&id=11ecbd72", function () {
      api.rerender('11ecbd72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/server-events/skyrace/r-sky-sprint-config-page.vue"
export default component.exports